import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'hedron';
import { BackImage, TitleWrapper } from './FiltersModal.css';
import FilterTitle from '../FilterTitle';

const FilterModalHeader = ({ s3BasePath, toggle }) => (
  <div style={{ padding: 10 }}>
    <Row>
      <Column fluid style={{ position: 'relative' }}>
        <TitleWrapper>
          <BackImage src={`${s3BasePath}mkt/icon/arrow_left_black.png`} onClick={toggle} />
          <FilterTitle bold>refine by</FilterTitle>
        </TitleWrapper>
      </Column>
    </Row>
  </div>
);

FilterModalHeader.propTypes = {
  s3BasePath: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired
};
export default FilterModalHeader;
